import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from './auth'; // A função de autenticação que criamos

const PrivateRoute = () => {
    //return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
    const location = useLocation();

    // Verifica se o usuário está autenticado
    if (isAuthenticated()) {
        return <Outlet />;
    }

    console.log(location.pathname);
    // Caso não esteja autenticado, redireciona para '/' ou '/parceiro' com base na rota acessada
    const redirectPath = location.pathname === `/parceiro` ? `/parceiro` : `/`;
        
    return <Navigate to={redirectPath} />;
};

export default PrivateRoute;
